export const appConfig = {
  auth0Domain: process.env.NEXT_PUBLIC_AUTH0_DOMAIN,
  auth0ClientId: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID,
  amplitudeApiKey: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
  connectionDB: process.env.NEXT_PUBLIC_CONNECTION_DB,
  applyRedirect: process.env.NEXT_PUBLIC_APPLY_REDIRECT,
  isDetermineEnable: process.env.NEXT_PUBLIC_ENABLE_DETERMINE !== 'false',
  isProduction: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
};
